import React from "react";

const getFileIcon = (fileName) => {
  const extension = fileName.split('.').pop().toLowerCase();
  
  const iconMap = {
    'pdf': '📄',
    'csv': '📊',
    'xlsx': '📊',
    'xls': '📊',
    'doc': '📝',
    'docx': '📝',
    'txt': '📝',
    'jpg': '🖼️',
    'jpeg': '🖼️',
    'png': '🖼️',
    'gif': '🖼️',
    'zip': '📦',
    'rar': '📦'
  };

  return iconMap[extension] || '📄'; // Default icon for unknown types
};

export default (params) => {
  if (!params.value) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ fontSize: '20px' }}>{getFileIcon(params.value)}</span>
      <span>{params.value}</span>
    </div>
  );
};